import { Organization } from '../models';
import { Organization as OrganizationEntity } from 'adc-sirius-module-common';
import { urls } from '../utilities/dataHelpers';
import {
  mapOrganizationEntityToOrganization,
  mapOrganizationToOrganizationEntity,
} from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';

const handleGetOrganizations = (
  request: MediatorRequestWithResponse<Organization[]>,
) => {
  const state = request.state;

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OrganizationEntity[]>('api:invoke', {
        method: 'GET',
        url: urls.api + 'organizations',
        queryString: state ? `?rowstate=${state}` : '',
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(
            result.data?.map((organizationEntity) =>
              mapOrganizationEntityToOrganization(organizationEntity),
            ) || [],
          );
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching organization:', err);
        reject(err);
      });
  });
};

const handleGetOrganizationByKey = (
  request: MediatorRequestWithResponse<Organization>,
) => {
  request.response = new Promise((resolve, reject) => {
    const organizationKey = request.key;

    mediator
      .request<OrganizationEntity>('api:invoke', {
        method: 'GET',
        url: `${urls.api}organizations/${organizationKey}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapOrganizationEntityToOrganization(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching organization by ID:', err);
        reject(err);
      });
  });
};

const handleCreateOrganization = (
  request: MediatorRequestWithResponse<Partial<Organization>>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OrganizationEntity>('api:invoke', {
        method: 'POST',
        url: urls.api + 'organizations',
        data: mapOrganizationToOrganizationEntity(request.data),
      })
      .then((result) => {
        if (result.status === 201) {
          resolve(mapOrganizationEntityToOrganization(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error creating organization:', err);
        reject(err);
      });
  });
};

const handleUpdateOrganization = (
  request: MediatorRequestWithResponse<Partial<Organization>>,
) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OrganizationEntity>('api:invoke', {
        method: 'PUT',
        url: `${urls.api}organizations`,
        data: mapOrganizationToOrganizationEntity(request.data),
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapOrganizationEntityToOrganization(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error updating organization:', err);
        reject(err);
      });
  });
};

mediator.subscribe('organization:getOrganizations', handleGetOrganizations);
mediator.subscribe(
  'organization:getOrganizationByKey',
  handleGetOrganizationByKey,
);
mediator.subscribe('organization:createOrganization', handleCreateOrganization);
mediator.subscribe('organization:updateOrganization', handleUpdateOrganization);
